import React, { useState } from 'react';
import { IStep, PageContents } from './StrategyExercisePlan';
import { AddRowButton, StyledRowNumberContainer, StyledSelectionSolutionArea, StyledSelectSolutionContainer, StyledSolution, StyledSolutionArea } from './StrategyExercisePlan.styled';
import { STEPS } from 'models/exercises/IExercisePlan';
import { PlanActivityTextField } from 'components/TextField/PlanActivityTextField';

interface IStepTwoProps extends IStep {
  setSolutions: React.Dispatch<React.SetStateAction<string[]>>
}

export const StepTwoPage: React.FC<IStepTwoProps> = ({ content, setStep, setSolutions, handleError }) => {
  const [fields, setFields] = useState<string[]>(['', '', '', '']);
  const NUM_OF_SOLUTIONS_NEEDED = 3;
  const errorMessage = 'Generate at least 3 solutions';

  const handleFieldChange = (index: number) => (newValue: string) => {
    const updatedFields = [...fields];
    updatedFields[index] = newValue;
    setFields(updatedFields);
  };

  const addNewField = () => {
    setFields([...fields, '']);
  };

  const onCtaClick = () => {
    const filledFields = fields.filter((field) => field.trim() !== '');

    if (filledFields.length < NUM_OF_SOLUTIONS_NEEDED) {
      handleError && handleError({ isError: true, errorMessage: errorMessage });
      return;
    }

    handleError && handleError({ isError: false, errorMessage: '' })
    setSolutions(filledFields);
    setStep(STEPS.STEP_TWO_B); 
  };
  
  return (
    <React.Fragment>
      <PageContents content={content} onCtaClick={onCtaClick}>
        <StyledSolutionArea>
          {fields.map((field, index) => (
            <PlanActivityTextField onChange={handleFieldChange(index)} fieldNumber={`${index + 1}.`} placeholder={''} initialValue={field} key={index}/>
          ))}
        </StyledSolutionArea>
        <AddRowButton onClick={addNewField}>+ another row</AddRowButton>
      </PageContents>
    </React.Fragment>
  )
}

interface IStepTwoBProps extends IStep {
  solutions: string[],
  setSelectedSolution: React.Dispatch<React.SetStateAction<string[]>>
}

export const StepTwoBPage: React.FC<IStepTwoBProps> = ({ content, setStep, solutions, handleError, setSelectedSolution }) => {
  const [selectedIndices, setSelectedIndices] = useState<number[]>([]);
  const NUM_OF_SOLUTIONS_NEEDED = 2;
  const errorMessage = 'Select two possible solutions';

  const onCtaClick = () => {
    if (selectedIndices.length !== NUM_OF_SOLUTIONS_NEEDED) {
      handleError && handleError({ isError: true, errorMessage });
      return;
    }

    handleError && handleError({ isError: false, errorMessage: '' })
    setSelectedSolution(solutions.filter((s) => selectedIndices.includes(solutions.indexOf(s))));
    setStep(STEPS.STEP_THREE); 
  }

  const handleSelection = (index: number) => {
    if (selectedIndices.includes(index)) {
      setSelectedIndices(selectedIndices.filter(i => i !== index));
    } else {
      setSelectedIndices([...selectedIndices, index]);
    }
  };

  return (
    <PageContents content={content} onCtaClick={onCtaClick}>
      <StyledSelectionSolutionArea>
        {solutions.map((solution, index) => (
          <StyledSelectSolutionContainer key={index} $isSelected={selectedIndices.includes(index)} onClick={() => handleSelection(index)}>
            <StyledRowNumberContainer><span>{index + 1}.</span></StyledRowNumberContainer>
            <StyledSolution><span>{solution}</span></StyledSolution>
          </StyledSelectSolutionContainer>
        ))}
      </StyledSelectionSolutionArea>
    </PageContents>
  )
}